import { useEffect } from "react";

const SUFFIX = "Storosilov Vintage";

// Устанавливает document.title (важно для вкладок браузера и шеринга на сайте).
// Передавай короткую часть — суффикс с названием магазина добавится сам.
export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    document.title = title ? `${title} — ${SUFFIX}` : SUFFIX;
    return () => { document.title = SUFFIX; };
  }, [title]);
}
